var map = {
	"./planet-earth-geology.png": "b63a",
	"./planet-jupiter-geology.png": "8c5c",
	"./planet-mars-geology.png": "74ba",
	"./planet-mercury-geology.png": "f4ed",
	"./planet-neptune-geology.png": "93e2",
	"./planet-saturn-geology.png": "076a",
	"./planet-uranus-geology.png": "a730",
	"./planet-venus-geology.png": "715d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ca0e";